import { authHeader, authHeaderUpload, handleResponse } from '@/api/handler/main';

export const lotteryService = {
    registerExternalLottery,
    updateExternalLotteryFile,
    getExternalImportStatus,
    getExternalDataColumns,
    listLottery,
    detailLottery,
    registerLottery,
    updateLottery,
    deleteLottery,
    settingLottery,
    candidatesPreview,
    exportCandidates,
    drawLottery,
    drawStatus,
    listWinners,
    addWinner,
    updateWinner,
    deleteWinner,
    exportWinners
};

function listLottery(query) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries?` + query, requestOptions).then(handleResponse);
}

function detailLottery(id) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/` + id, requestOptions).then(handleResponse);
}

function registerLottery(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries`, requestOptions).then(handleResponse);
}

function updateLottery(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/` + data.id, requestOptions).then(handleResponse);
}

function deleteLottery(id) {
    const requestOptions = { method: 'DELETE', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/` + id, requestOptions).then(handleResponse);
}

// PUT /lotteries/{id}/settings
function settingLottery({ id, data }) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/settings`, requestOptions).then(handleResponse);
}

// GET /lotteries/{id}/candidates/preview
function candidatesPreview({ id, query }) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/candidates/preview?${query}`, requestOptions).then(handleResponse);
}

// POST /lotteries/{id}/candidates/export
function exportCandidates({ id, query }) {
    const requestOptions = { method: 'POST', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/candidates/export?${query}`, requestOptions).then(handleResponse);
}

// POST /lotteries/{id}/draws
function drawLottery({ id, data }) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: data ? JSON.stringify(data) : ''
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/draws`, requestOptions).then(handleResponse);
}

// GET /lotteries/{id}/draws/{draw_id}/status
function drawStatus({ lotteryId, drawId }) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${lotteryId}/draws/${drawId}/status`, requestOptions).then(handleResponse);
}

// GET /lotteries/{id}/winners?filters[reward_text]=xxx
function listWinners({ id, query }) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/winners?${query}`, requestOptions).then(handleResponse);
}

// POST /lotteries/{id}/winners
function addWinner({ lotteryId, data }) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${lotteryId}/winners`, requestOptions).then(handleResponse);
}

// POST /lotteries/{id}/winners
function updateWinner({ lotteryId, id, data }) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${lotteryId || id}/winners`, requestOptions).then(handleResponse);
}

// DELETE /lotteries/{id}/winners
function deleteWinner({ lotteryId, id, data }) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${lotteryId || id}/winners`, requestOptions).then(handleResponse);
}

// POST /lotteries/{id}/winners/export
function exportWinners({ id, query }) {
    const requestOptions = { method: 'POST', headers: authHeader() };
    const queryString = query ? `?${query}` : '';
    return fetch(process.env.VUE_APP_APIURL + `/lotteries/${id}/winners/export${queryString}`, requestOptions).then(handleResponse);
}

function registerExternalLottery(formData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeaderUpload(),
        body: formData
    };
    return fetch(process.env.VUE_APP_APIURL + '/lotteries/external-data', requestOptions).then(handleResponse);
}

function updateExternalLotteryFile(id, formData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeaderUpload(),
        body: formData
    };
    return fetch(process.env.VUE_APP_APIURL + '/lotteries/external-data/' + id, requestOptions).then(handleResponse);
}

function getExternalImportStatus(lotteryId, importId) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + '/lotteries/' + lotteryId + '/external-data/imports/' + importId + '/status', requestOptions).then(
        handleResponse
    );
}

function getExternalDataColumns(id) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(process.env.VUE_APP_APIURL + '/lotteries/' + id + '/external-data/columns', requestOptions).then(handleResponse);
}
